// These schemas should match their corresponding DB model in @performyard/models
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskQuery () {
        return AutoflowTaskQuery;
    },
    get AutoflowTaskQueryBase () {
        return AutoflowTaskQueryBase;
    },
    get AutoflowTaskQueryCompany () {
        return AutoflowTaskQueryCompany;
    },
    get AutoflowTaskQueryCompanyResponse () {
        return AutoflowTaskQueryCompanyResponse;
    },
    get AutoflowTaskQueryConfigQueries () {
        return AutoflowTaskQueryConfigQueries;
    },
    get AutoflowTaskQueryResponse () {
        return AutoflowTaskQueryResponse;
    },
    get AutoflowTaskQueryUser () {
        return AutoflowTaskQueryUser;
    },
    get AutoflowTaskQueryUserQuery () {
        return AutoflowTaskQueryUserQuery;
    },
    get AutoflowTaskQueryUserResponse () {
        return AutoflowTaskQueryUserResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _taskbase = require("./task-base");
const AutoflowTaskQueryBase = _taskbase.AutoflowTaskBase.extend({
    taskType: _zod.z.literal("query:")
});
const AutoflowTaskQueryUserQuery = _models.CohortQueryModel;
const AutoflowTaskQueryUser = AutoflowTaskQueryBase.extend({
    taskType: _zod.z.literal("query:user"),
    config: _zod.z.object({
        query: AutoflowTaskQueryUserQuery
    })
});
const AutoflowTaskQueryUserResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskQueryUser).extend({
    outputs: _zod.z.object({
        userIds: _utilsisomorphic.transformObjectId.array()
    })
});
// Company queries (not implemented)
const companyQuery = _zod.z.object({});
const AutoflowTaskQueryCompany = AutoflowTaskQueryBase.extend({
    taskType: _zod.z.literal("query:company"),
    config: _zod.z.object({
        query: companyQuery
    })
});
const AutoflowTaskQueryCompanyResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskQueryCompany);
const AutoflowTaskQueryConfigQueries = _zod.z.union([
    AutoflowTaskQueryUserQuery,
    companyQuery
]);
const AutoflowTaskQuery = _zod.z.discriminatedUnion("taskType", [
    AutoflowTaskQueryUser,
    AutoflowTaskQueryCompany
]);
const AutoflowTaskQueryResponse = _zod.z.discriminatedUnion("taskType", [
    AutoflowTaskQueryUserResponse,
    AutoflowTaskQueryCompanyResponse
]);
